import {
  ImportCSVErrorMessage,
  ImportCSVFormDataField,
  ValidateImportCSVFieldsArguments,
} from '@components/process-import-csv/process-import-csv.type';

import {
  bookingFields,
  ERROR_COLUMN_MESSAGE,
  ERROR_MESSAGE,
  FIELD_FIRST_NAME,
  FIELD_FULL_NAME,
  FIELD_LAST_NAME,
  FIELD_QR_CODE,
} from '../constants';

const hasDuplicateError = (set: Set<ImportCSVErrorMessage>, error: ImportCSVErrorMessage) => {
  for (const item of set) {
    if (item.literal === error.literal && item.message === error.message) {
      return true;
    }
  }
  return false;
};

const createGeneralErrors = ({
  field,
  colIndex,
  columnSet,
  globalErrors,
}: {
  globalErrors: Set<ImportCSVErrorMessage>;
  columnSet: Set<string>;
  field: ImportCSVFormDataField;
  colIndex: number;
}) => {
  if (columnSet.has(field.field)) {
    globalErrors.add({
      literal: ERROR_COLUMN_MESSAGE,
      columnValue: colIndex,
      columnLabel: colIndex + 1,
      message: 'errors:generalErrorDuplicatedColumn',
    });
  } else if ((columnSet.has(FIELD_FIRST_NAME) || columnSet.has(FIELD_LAST_NAME)) && columnSet.has(FIELD_FULL_NAME)) {
    const nameFullNameError = { literal: ERROR_MESSAGE, message: 'errors:generalErrorNameFullName' };
    if (!hasDuplicateError(globalErrors, nameFullNameError)) globalErrors.add(nameFullNameError);
  } else if (field.field) {
    columnSet.add(field.field);
  }
};

const createColumnErrors = ({ rule, colIndex }: { rule?: string | boolean | number[]; colIndex: number }) => {
  const columnErrors: ImportCSVErrorMessage[] = [];
  if (rule) {
    if (typeof rule === 'string') {
      columnErrors.push({
        literal: ERROR_COLUMN_MESSAGE,
        columnValue: colIndex,
        columnLabel: colIndex + 1,
        message: rule,
      });
    } else if (typeof rule === 'object') {
      const numberArrayValidation = rule;
      if (numberArrayValidation.length !== 0) {
        let rows = '';
        numberArrayValidation.forEach((error, numIndex) => {
          rows += ` ${error + 1}${numberArrayValidation.length === numIndex + 1 ? '' : ','}`;
        });
        columnErrors.push({
          literal: 'errors:columnRowsMessage',
          columnValue: colIndex,
          columnLabel: colIndex + 1,
          message: rows,
        });
      }
    }
  }
  return columnErrors;
};

export const validateFields = ({ formData, processedColumns }: ValidateImportCSVFieldsArguments) => {
  if (!formData) return;
  const generalErrors = new Set<ImportCSVErrorMessage>();
  const columnSet = new Set<string>();
  const columnErrors: ImportCSVErrorMessage[] = [];
  const qrCodeColumnIndex = formData.findIndex((col) => col?.field === FIELD_QR_CODE);
  if (qrCodeColumnIndex === -1) generalErrors.add({ literal: ERROR_MESSAGE, message: 'errors:generalErrorQrCode' });

  formData.forEach((field, colIndex) => {
    const columnData = processedColumns[colIndex];
    const validationRule = bookingFields.find((bookingField) => bookingField.id === field.field)?.validationRules;

    createGeneralErrors({ field, colIndex, columnSet, globalErrors: generalErrors });
    columnErrors.push(...createColumnErrors({ colIndex, rule: validationRule?.(columnData) }));
  });
  const errorData = { generalErrors, columnErrors, qrCodeColumnIndex };
  return errorData;
};
